export default __webpack_public_path__ + "assets/images/1587048e4f43719dc1156a21ab38a0da.png";